import Backbone from "backbone";
import $ from "jquery";

export default Backbone.View.extend({

    initialize: function () {
      this.input = this.$(".js-switch-input--on");
      this.render();
    },

    events: {
      "click .js-Toggle-optionInputs": "render"
    },

    render: function () {
      if (this.input.is(':checked')) {
        this.$(".js-Toggle-content").show();
      } else {
        this.$(".js-Toggle-content").hide();
      }
    }

  });
